import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const links = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Classes',
    href: '#classes'
  }, {
    name: 'Training',
    href: '#training'
  }, {
    name: 'Results',
    href: '#results'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-prt-darker h-[60px] flex items-center border-b border-white/10" data-id="element-19">
      <div className="container mx-auto px-6 flex items-center justify-between h-full" data-id="element-20">
        <a href="#" className="flex items-center gap-2 text-white font-heading text-2xl tracking-wider" data-id="element-21">
          <img src="https://cdn.magicpatterns.com/uploads/hgMw6coYeViNRp9G1BXrEW/New_PRT_Logo.png" alt="PRT logo" className="h-9 w-9 object-contain" data-id="element-22" />
          <span data-id="element-23">PRT</span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-24">
          <div className="flex space-x-6" data-id="element-25">
            {links.map(link => <a key={link.name} href={link.href} className="text-white hover:text-prt-blue transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-26">
                {link.name}
              </a>)}
          </div>
          <button className="bg-prt-blue hover:bg-prt-blue/90 text-white px-6 py-2 rounded font-heading tracking-wider text-lg transition-colors" data-id="element-27">
            Get Started
          </button>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setIsOpen(!isOpen)} data-id="element-28">
          {isOpen ? <X size={24} data-id="element-29" /> : <Menu size={24} data-id="element-30" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="absolute top-[60px] left-0 right-0 bg-prt-darker border-b border-white/10 md:hidden flex flex-col p-6 space-y-4 shadow-xl" data-id="element-31">
          {links.map(link => <a key={link.name} href={link.href} className="text-white text-lg font-medium uppercase tracking-wider" onClick={() => setIsOpen(false)} data-id="element-32">
              {link.name}
            </a>)}
          <button className="bg-prt-blue text-white w-full py-3 rounded font-heading tracking-wider text-xl mt-4" data-id="element-33">
            Get Started
          </button>
        </div>}
    </nav>;
}